import { getRepository } from './repository';

const resource = "/session";

export default {
    sessionDetails(headers) {
        return getRepository().get(`${resource}/details`, { headers : headers });
    }
};